import PropTypes from "prop-types";
import { InputAdornment, TextField, CircularProgress } from "@mui/material";
import Iconify from "../../components/Iconify";
import React from "react";
import { makeStyles } from "@mui/styles";
import useLocales from "../../hooks/useLocales";
// Use a small inline loader inside the input instead of the full-screen content loader

const useStyles = makeStyles((theme) => ({
  searchIcon: {
    color: theme.palette.text.disabled,
    width: 30,
    height: 20
  }
}));

SearchTableToolbar.propTypes = {
  searching: PropTypes.bool,
  filterValue: PropTypes.string,
  onSearch: PropTypes.func,
  tableSearchBy: PropTypes.string
};

export default function SearchTableToolbar({
  searching = false,
  searchQuery,
  onSearch,
  tableSearchBy,
  disabled = false,
  searchByPlaceholder
}) {
  const styles = useStyles();
  const { translate } = useLocales();
  const [inputValue, setInputValue] = React.useState(searchQuery);
  const textFieldRef = React.useRef(null);

  React.useEffect(() => {
    focusSearchTextField();
  }, []);

  // Keep the input value in sync when parent-controlled searchQuery changes
  React.useEffect(() => {
    setInputValue(searchQuery || "");
  }, [searchQuery]);

  function focusSearchTextField() {
    if ((searchQuery?.length ?? 0) > 0) {
      textFieldRef.current.focus();
    }
  }

  function handleSubmit() {
    focusSearchTextField();
    onSearch(inputValue);
  }

  const handleInputChange = (event) => {
    const query = event.target.value;
    setInputValue(query);
    onSearch(query);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <TextField
      height="100px"
      id="search-bar"
      onChange={handleInputChange}
      label={searchByPlaceholder}
      fullWidth
      disabled={disabled}
      value={inputValue}
      onKeyDown={handleKeyDown}
      inputRef={textFieldRef}
      autoComplete="off"
      inputProps={{ maxLength: 30 }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            {searching ? (
              <CircularProgress size={18} thickness={5} />
            ) : (
              <Iconify
                icon={"eva:search-fill"}
                className={styles.searchIcon}
                style={{ cursor: "pointer" }}
                onClick={handleSubmit}
              />
            )}
          </InputAdornment>
        )
      }}
    />
  );
}
